<template>
  <v-dialog v-model="dialog" :overlay="false" scrollable width="650">
    <v-card tile flat>
      <v-toolbar dark color="primary">
        <v-app-bar-nav-icon><v-icon>group_add</v-icon></v-app-bar-nav-icon>
        <v-toolbar-title>
          Register a new customer
          <span v-if="referralDetails">: {{ referralDetails.company_name }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <customer-registration :referral-details="referralDetails" :show="show"></customer-registration>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CustomerRegistration from './CustomerRegistration';

export default {
  name: 'customer-registration-dialog',
  components: { CustomerRegistration },
  props: ['show', 'referralDetails'],
  data: () => ({}),
  computed: {
    ...mapGetters(['UserHasRole']),
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    }
  },
  methods: {
    ...mapActions(['clearRegistration', 'getReferralsPage']),
    closeDialog() {
      if (this.UserHasRole('Broker')) {
        this.getReferralsPage();
      }
      this.clearRegistration();
      this.dialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  div.list__tile,
  .subheader {
    padding: 0 16px 0 0;
  }

  input,
  label {
    font-size: 14px;
  }
}

address {
  font-style: normal;
}
</style>
